import React from 'react';

import Dossier from '../../../../components/Molecules/Dossier';
import Carousel from '../../../../components/Carousel';

import './style.scss';

const ExplainerSlider = ({ items }) => {

  return (
    <div className="ContentSlider">
      <Carousel numberOfSlides="2">
        {items && items.map((item) => {
          const itemBody = item.getIn(['entity', 'field_plain_body', 0, 'value'], '');
          const imageBundle = item.getIn(['entity', 'field_media_image', 0, 'bundle']);
          const uuid = item.getIn(['entity', 'uuid', 0, 'value']);
          let image;

          if (imageBundle === 'image') {
            image = item.getIn(['entity', 'field_media_image', 0, 'styles', 'dossier_card'], false);
          } else if (imageBundle === 'svg') {
            image = item.getIn(['entity', 'field_media_image', 0, 'entity', 'field_media_svg', 0, 'url'], false);
          } else if (imageBundle === 'lottie') {
            image = item.getIn(['entity', 'field_media_image', 0, 'entity', 'field_media_file', 0, 'url'], false);
          }
          return (
            <Dossier
              className="item"
              key={uuid}
              body={itemBody}
              image={image || ''}
              imageBundle={imageBundle}
            />
          );
        })}
      </Carousel>
    </div>
  );
};

export default ExplainerSlider;
